export default {
  root: '/',
  signIn: 'sign-in',
  consent: 'consent',
  termsConditions: 'terms-conditions',
  privacyPolicy: 'privacy-policy',
  resetPassword: 'reset-password',
  unlockUser: 'unlock-user',
};
